import axios from "axios";
import { api } from "../config";

interface createAction {
  Title: string;
  Type: string;
  Source: string;
  Payload: any;
  Ref: string;
}

const createAction = async (data: createAction) => {
  const action = await axios.post(`${api}/actions`, { data });
  return action;
};

export {createAction}